import './App.css';
import React, { useState } from 'react';
import { Outlet, Link } from "react-router-dom";
import { getReleases } from "./data";
import { Helmet } from 'react-helmet';


class NavBarEntry extends React.Component {
  constructor(props) {
    super(props)
    this.state = { open: true }
  }

  render() {

    if (this.state.open) {
      return (
        <div>
          <li className='titleButton' onClick={() => { this.setState({ open: !this.state.open }) }}>{this.props.title}</li>
          {this.props.content}
        </div>
      )
    }
    else {
      return (
        <div>
          <li className='titleButton' onClick={() => { this.setState({ open: !this.state.open }) }}>{this.props.title}</li>
        </div>
      )
    }

  }

}

class NavBar extends React.Component {

  constructor(props) {
    super(props)
    this.state = { open: false }
  }

  render() {
    const releases = this.props.releases
    const releaseList = releases.map((group) =>
      <ul className='listContainer'>
        <div className='entryGroup'>
          <NavBarEntry
            title={group.name}
            content={group.items.map((release) =>
              <div className='entry entryRelease'>
                <li>{release.name}</li>
                <div className='dropDown'>
                  {release.short === "short" ?
                    <>
                      <Link to={"/shortreader/?target=" + release.index}>Read Online</Link>
                      <Link to={"/infopage/?target=" + release.index}>View Info</Link>
                    </>
                    :
                    <>
                      <Link to={"/pdfreader/?target=" + release.index}>Read PDF</Link>
                      <Link to={"/epubreader/?target=" + release.index}>Read EPUB</Link>
                      <Link to={"/infopage/?target=" + release.index}>View Info</Link>
                    </>
                  }
                </div>
              </div>
            )}></NavBarEntry>
        </div>

      </ul>
    )

    if (this.state.open) {
      return (
        <div className='navBar'>
          <button className='closeButton' onClick={() => { this.setState({ open: !this.state.open }) }}>&lt;</button>
          {releaseList}
        </div>
      )
    }
    else {
      return (
        <div className='navBar'>
          <button className='closeButton' onClick={() => { this.setState({ open: !this.state.open }) }}>&gt;</button>
        </div>
      )
    }
  }
}

function App() {

  const releases = getReleases()

  return (
    <div>
      <Helmet>
        <script defer src="https://cloud.umami.is/script.js" data-website-id="ac1b614a-9746-4726-9162-c6d19940e6d0"></script>
      </Helmet>
      <div>
        <NavBar releases={releases} />
        <div className='contentFlex'>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default App;
